// GOTU-1136: RDH Booking Fee accepts 0.00-100.00 with up to 2 decimal places.
// Mirrors the BE validator in tempmee_server (services/dso/dso.ts).

export const BOOKING_FEE_MIN = 0;
export const BOOKING_FEE_MAX = 100;
export const BOOKING_FEE_MAX_DECIMALS = 2;

const BOOKING_FEE_PATTERN = /^\d+(\.\d{1,2})?$/;

export const isValidBookingFeeInput = (rawValue) => {
  if (rawValue === null || rawValue === undefined) return false;
  const trimmed = String(rawValue).trim();
  if (trimmed === '') return false;
  if (!BOOKING_FEE_PATTERN.test(trimmed)) return false;

  const parsed = Number(trimmed);
  if (!Number.isFinite(parsed)) return false;
  return parsed >= BOOKING_FEE_MIN && parsed <= BOOKING_FEE_MAX;
};

export const parseBookingFee = (rawValue) => {
  if (!isValidBookingFeeInput(rawValue)) return null;
  return Number(String(rawValue).trim());
};

export const formatBookingFeeDisplay = (rate) => {
  if (rate === null || rate === undefined || Number.isNaN(Number(rate))) return '-';
  return `${Number(Number(rate).toFixed(BOOKING_FEE_MAX_DECIMALS))}%`;
};
